export function Logo({ size = 32, className = '' }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden="true"
    >
      <rect width="32" height="32" rx="9" fill="#ec4899" />
      <rect x="7" y="14" width="18" height="12" rx="2" fill="white" opacity="0.95" />
      <path
        d="M7 14h18l-2.2-3.2a2 2 0 0 0-1.7-.9H10.9a2 2 0 0 0-1.7.9L7 14z"
        fill="white"
      />
      <path
        d="M16 11.5v14.5M11.5 14.8h9"
        stroke="#db2777"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <circle cx="16" cy="11.5" r="2.2" fill="#db2777" stroke="white" strokeWidth="1.2" />
    </svg>
  );
}

export default Logo;
